import { Tooltip } from '@innovationdepartment/proxima-ui';
import { DeleteOutlineRounded } from '@mui/icons-material';
import { useId } from 'react';
import { IconButton, VisuallyHidden } from './shared.styles';

type DeleteButtonProps = {
  audienceName: string;
  /**
   * Why the audience cannot be deleted yet, or null.
   *
   * A reason disables the button and becomes its tooltip and accessible description.
   */
  blockedReason: string | null;
  disabled?: boolean;
  onClick: () => void;
};

/* Opens the delete dialog for a definition */
const DeleteButton = ({ audienceName, blockedReason, disabled, onClick }: DeleteButtonProps) => {
  const reasonId = useId();
  return (
    <Tooltip title={blockedReason ?? 'Delete audience'}>
      <span>
        <IconButton
          type="button"
          disabled={disabled || blockedReason != null}
          onClick={onClick}
          aria-label={`Delete ${audienceName}`}
          aria-describedby={blockedReason ? reasonId : undefined}
        >
          <DeleteOutlineRounded />
        </IconButton>
        {blockedReason ? <VisuallyHidden id={reasonId}>{blockedReason}</VisuallyHidden> : null}
      </span>
    </Tooltip>
  );
};

export default DeleteButton;
